import { render, staticRenderFns } from "./tourPage02.vue?vue&type=template&id=8b1b8826&scoped=true&"
import script from "./tourPage02.vue?vue&type=script&lang=js&"
export * from "./tourPage02.vue?vue&type=script&lang=js&"
import style0 from "./tourPage02.vue?vue&type=style&index=0&id=8b1b8826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1b8826",
  null
  
)

export default component.exports